import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { Sun, Moon } from 'lucide-react';

const Navbar = ({
  onHomeClick,
  onFeaturesClick,
  onContactClick,
  theme,
  onThemeToggle,
  onJoinClick
}) => {
  const [scrolledPastHero, setScrolledPastHero] = useState(false);
  const handleHome = (e) => { e.preventDefault(); if (onHomeClick) onHomeClick(); };
  const handleFeatures = (e) => { e.preventDefault(); if (onFeaturesClick) onFeaturesClick(); };
  const handleContact = (e) => { e.preventDefault(); if (onContactClick) onContactClick(); };
  const handleJoin = (e) => { e.preventDefault(); if (onJoinClick) onJoinClick(); };

  const handleToggle = () => {
    if (onThemeToggle) return onThemeToggle();
    try {
      const current = document.documentElement.getAttribute('data-theme');
      const next = current === 'dark' ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', next);
      localStorage.setItem('theme', next);
    } catch (e) {
      // ignore
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      // Get the hero section height (approximately 100vh)
      const heroHeight = window.innerHeight;

      // Check if we've scrolled past the hero section
      const scrolled = window.scrollY > heroHeight * 0.8; // Using 80% of hero height as threshold

      setScrolledPastHero(scrolled);
    };

    // Initial check
    handleScroll();

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Cleanup event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`hero-header ${scrolledPastHero ? 'scrolled' : ''}`}>
      <div className="header-content">
        <div className="logo-section">
          <div className="logo-icon">
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Expert Supply Chain Logo" width={50} />
          </div>
          <div className="logo-text">
            <div className="logo-main">Expert Supply Chain</div>
            <div className="logo-slogan">Nationwide Logistics Solutions</div>
          </div>
        </div>
        <nav className="hero-nav">
          <a href="#home" className="nav-link active" onClick={handleHome}>Home</a>
          <a href="#features" className="nav-link" onClick={handleFeatures}>Services</a>
          <a href="#contact" className="nav-link" onClick={handleContact}>Contact</a>
          <button className="theme-toggle" onClick={handleToggle} aria-label={`Toggle theme, current ${theme}`} title={`Theme: ${theme}`}>
            {theme === 'dark' ? <Moon size={18} /> : <Sun size={18} />}
          </button>
          <button className="join-now-btn" onClick={handleJoin}>Request Quote</button>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
